// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1gd0c","alertIcon":"ConfirmModal_alertIcon__2Hzty"};